import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ListButtonPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, title: string, height: number, callback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.height = height;

        let butt = SpriteUtils.addSprite(this.scene, 0, 50, Keys.GREEN_HORIZONTAL_BUTTON).setOrigin(0.5, 0.5);

        let buttText = TextUtils.addTextByFamily(scene, title, 0, butt.y / CU.S,
            '#ffffff', 18, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        butt.setInteractive().on('pointerup', () => {
            callback();
        });

        this.add([butt, buttText]);
    }

}
